import { ReactNode } from 'react';

import { Col, Container } from 'components/GridSystem';
import Header from 'components/Header';
import Footer from 'components/Footer';

import * as S from './styles';

type SuccessTemplateProps = {
  children: ReactNode;
  firstName: string;
  img: string;
};

const SuccessTemplate = ({
  children,
  firstName,
  img,
}: SuccessTemplateProps) => {
  return (
    <S.Container>
      <S.HeaderSection>
        <Header />
        <Container>
          <S.Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <S.Title>
                Welcome, {firstName}! <span>❤️</span>
              </S.Title>
              {children}
            </Col>
          </S.Row>
        </Container>
      </S.HeaderSection>

      <S.FooterSection>
        <S.Image src={img} alt="An image of a person celebrating" />
        <Footer variant="third" />
      </S.FooterSection>
    </S.Container>
  );
};

export default SuccessTemplate;
